import { UserOutlined } from '@ant-design/icons';
import { Avatar, Card, Col, Dropdown, Flex, Layout, Menu, Row } from 'antd';
import { ItemType, MenuItemType } from 'antd/es/menu/interface';
import { memo, Suspense, useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ModalConfirm, SpinnerLoader } from 'src/libraries';
import { AdminRouteMenus, RootRouteMenus, Routes } from 'src/routes';
import { AuthService } from 'src/services';
import { useAccount } from 'src/stores';
import { EAccountType } from 'src/types';
import { EVENTS, FUNCS } from 'src/utils';
import ModalChangePassword from './components/ModalChangePassword';
import ModalProfile from './components/ModalProfile';
import Notification from './components/Notification';
import SiderLayout from './sider';

const svAuth = new AuthService();

function LayoutClient() {
  const navigate = useNavigate();
  const { account, clear } = useAccount();

  const handleLogout = async () => {
    try {
      await svAuth.logout();
      clear();

      navigate(Routes.LOGIN.path as string);
    } catch (err) {
      console.log(err);
    }
  };
  const avartarDropdownItems = useMemo<any>(() => {
    return [
      {
        label: <p onClick={EVENTS.onShowModalProfile}>Thông tin cá nhân</p>,
        key: 'profile',
      },
      {
        label: <p onClick={EVENTS.onShowModalChangePassword}>Đổi mật khẩu</p>,
        key: 'changePassword',
      },
      {
        label: <p onClick={handleLogout}>Đăng xuất</p>,
        key: 'logout',
      },
    ];
  }, []);

  const menus = useMemo<ItemType<MenuItemType>[]>(() => {
    if (!account) return [];
    const routes = account.type === EAccountType.ROOT ? RootRouteMenus : AdminRouteMenus;

    return routes.map((i) => ({
      key: i.path,
      label: i.children ? i.title : <div onClick={() => navigate(i.path)}>{i.title}</div>,
      children: i.children
        ? i.children.map((e) => ({
            key: e.path,
            label: e.children ? e.title : <div onClick={() => navigate(e.path)}>{e.title}</div>,
            children: e.children
              ? e.children.map((x) => ({
                  key: x.path,
                  label: x.children ? x.title : <div onClick={() => navigate(x.path)}>{x.title}</div>,
                }))
              : undefined,
          }))
        : undefined,
    }));
  }, [account]);

  const { innerHeight: height } = window;

  return (
    <Layout hasSider={false}>
      <Layout.Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ flex: '1', display: 'flex', alignItems: 'center' }}>
          <img src="/favicon/icon.jpg" alt="" width="40" />
          <h3 style={{ color: 'white', margin: '0px 12px 0px 6px' }}>Radio VN</h3>
          <Menu theme="dark" mode="horizontal" items={menus} style={{ width: '80%' }} />
        </div>

        <Flex>
          <Notification />

          <Dropdown menu={{ items: avartarDropdownItems }} placement="bottomRight">
            {account?.avatar ? (
              <Avatar size="large" src={FUNCS.getFullUrl(account?.avatar)} style={{ cursor: 'pointer' }} />
            ) : (
              <Avatar
                size="large"
                style={{ cursor: 'pointer', backgroundColor: 'white' }}
                icon={<UserOutlined style={{ color: 'black' }} />}
              />
            )}
          </Dropdown>
        </Flex>
      </Layout.Header>

      <Layout.Content hasSider style={{ padding: 10, height: height - 90 }}>
        {/* <h3 style={{ marginBottom: 12 }}>{titleMap[keyScreen]}</h3> */}
        <Layout>
          <Row gutter={20}>
            <Col span={5}>
              <Card>
                <SiderLayout />
              </Card>
            </Col>
            <Col span={19}>
              <Suspense fallback={<SpinnerLoader bg={false} />}>
                <Outlet />
              </Suspense>
            </Col>
          </Row>
        </Layout>
      </Layout.Content>
      <Layout.Footer style={{ textAlign: 'center', padding: 0 }}>Radio VN ©2024 Created by Teli</Layout.Footer>
      <ModalConfirm />
      {account && <ModalProfile />}
      {account && <ModalChangePassword />}
    </Layout>
  );
}

export default memo(LayoutClient);
